module.exports = __webpack_public_path__ + "img/80ne.2473ec5e.svg";